import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { compose } from '@/utils/story-composer';

const Lottie = loadable(() => import('react-lottie-player/dist/LottiePlayerLight.modern'), { ssr: true });

/**
 * @param { object } animation object containing a filename containing the lottie animation JSON
 * @param { number } goTo Starting point of the animation in milliseconds
 * @param { bool } play Start or stop the animation
 * @param { object} renderingSettings SVG settings like preserveAspectRatio See: https://github.com/airbnb/lottie-web#other-loading-options for more options
 */
function LottiePlayer({ animation, goTo = 0, play = true, renderingSettings }) {
	let url;
	if (animation?.filename) {
		// because the file is JSON we can't use storyblok image compression. Therefore get it straight from the bucket
		url = animation.filename.replace('a.storyblok.com', 's3.amazonaws.com/a.storyblok.com');
	}

	return <Lottie goTo={goTo} play={play} path={url} rendererSettings={renderingSettings} />;
}

LottiePlayer.propTypes = {
	animation: PropTypes.shape({
		filename: PropTypes.string.isRequired,
	}),
	goTo: PropTypes.number,
	play: PropTypes.bool,
	renderingSettings: PropTypes.object,
};

export default LottiePlayer;

compose('lottie-player', LottiePlayer);
